import(/* webpackMode: "eager" */ "/codebuild/output/src4158368348/src/lore-ui/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4158368348/src/lore-ui/components/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/codebuild/output/src4158368348/src/lore-ui/components/providers/SessionProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/codebuild/output/src4158368348/src/lore-ui/components/providers/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WalletProvider"] */ "/codebuild/output/src4158368348/src/lore-ui/components/providers/WalletProvider.tsx");
